import { render, staticRenderFns } from "./IconCheckboxOn.vue?vue&type=template&id=a8d41358"
import script from "./IconCheckboxOn.vue?vue&type=script&lang=js"
export * from "./IconCheckboxOn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports